import React from 'react';

/**
 * Een eenvoudige spinner component met tekst voor de initiële laadtoestand.
 */
export const InitialLoadingSpinner: React.FC = () => {
  return (
    <div className="fixed inset-0 bg-background/80 backdrop-blur-sm z-[100] flex flex-col items-center justify-center">
      <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-primary mb-4"></div>
      <p className="text-lg text-foreground font-semibold">Moment geduld...</p>
      <p className="text-muted-foreground">We halen je organisatiegegevens op.</p>
    </div>
  );
}; 